import React from 'react';
import { connect } from "react-redux";

import _ from "lodash";
import ContactDetailsSlideview from "../../../components/Contacts/ContactDetails/ContactDetailsSlideview.jsx";
import Cell from '../components/cell';
import Timeseries from '../components/timeseries';
import EntityReport from '../components/reports';

import { Asset, User, Contact, Campaign, Share, Collection } from '../components/entities';

import styles from '../reports.module.scss';

import {
  ASSET,
  COLLECTION, USER, USER_GROUP,
  CONTACT, COMPANY
} from "../../../constants/entities.js"
import numeral from 'numeral';
import { localizedStrings } from '../../../../localization/index';
import userRoleService from "src/services/userRoles.service.js";
import { ReportContext } from '../view';
import { resetReportDownload } from 'src/legacy/redux/actions/reports.jsx';

const mapDispatchToProps = (dispatch) => {
  return {
    resetReportDownload: () => dispatch(resetReportDownload()),
  };
};

class EngagementReportView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedContact: null,
    }

    this.showContactsView = this.showContactsView.bind(this);

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedHeaders = this.localizedReport.tabs.commons.headers;
  }

  componentDidMount() {
    this.props.trackAdoptionMetricsForReportsToggledViewEvent('Engagement');
  }

  showContactsView(recipientContact) {
    this.setState({
      selectedContact: recipientContact
    })
  }

  render() {
    return (
      <ReportContext.Consumer>
        {(contextObj) => (
          <div className={styles.grid}>
            <Cell>
              <AssetAttentionTimeReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchEngagementAttentionTimeGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <UniqueViewerReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchEngagementUniqueViewersGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <ShareReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchEngagementShareGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>

            <Cell column={2}>
              <AssetViewReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchEngagementAssetViewsGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell empty></Cell>

            <Cell>
              <PopularAssetsReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchEngagementPopularAssets(request, page, limit)
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <TopViewersReport request={contextObj.filter} showContactsView={this.showContactsView} fetchData={(request, page, limit) => {
                this.props.fetchEngagementTopUsers(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <TopAccountsReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchEngagementTopAccounts(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>

            <Cell>
              <CampaignsReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchEngagementCampaigns(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <CampaignSourcesReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchEngagementCampaignSources(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <ShareActivitiesReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchEngagementShareReport(request, page, limit)
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            {userRoleService.canAccessCollection() &&
              <Cell>
                <CollectionActivitiesReport request={contextObj.filter} fetchData={(request, page, limit) => {
                  this.props.fetchEngagementCollectionActivityReport(request, page, limit);
                }}
                  downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                  download={this.props.download}
                />
              </Cell>
            }
            <ContactDetailsSlideview onClose={() => this.setState({ selectedContact: null })} selectedContact={this.state.selectedContact} />
          </div>)}
      </ReportContext.Consumer>
    );
  }
}

const AssetAttentionTimeReport = connect(
  (state, ownProps) => {
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;
    return {
      title: localizedEngagement.cards.attention_time,
      loading: state.legacyRootReducer.reports.engagement.attentionTime.loading,
      data: state.legacyRootReducer.reports.engagement.attentionTime.item,
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      tickFormater: (value) => {
        const minutes = numeral(Math.floor(value / 60)).format('00');
        const seconds = numeral(Math.floor(value % 60)).format('00');
        return `${minutes}:${seconds}`;
      },
      valueFormater: (value) => {
        const minutes = numeral(Math.floor(value / 60)).format('00');
        const seconds = numeral(Math.floor(value % 60)).format('00');
        return `${minutes}:${seconds}`;
      },
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.avg_time
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.attention_time
    };
  }
)(Timeseries);

const UniqueViewerReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.engagement.uniqueViewers.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedEngagement.cards.unique_viewers} (${count})`,
      loading: state.legacyRootReducer.reports.engagement.uniqueViewers.loading,
      data: state.legacyRootReducer.reports.engagement.uniqueViewers.item,
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.unique_viewers
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.unique_viewers,
      canFilterByUserType: true
    };
  }
)(Timeseries);

const ShareReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.engagement.sharesGraph.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedEngagement.cards.shares} (${count})`,
      loading: state.legacyRootReducer.reports.engagement.sharesGraph.loading,
      data: state.legacyRootReducer.reports.engagement.sharesGraph.item,
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.shares
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.shares
    };
  }
)(Timeseries);

const AssetViewReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.engagement.assetViewsGraph.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedEngagement.cards.asset_views} (${count})`,
      loading: state.legacyRootReducer.reports.engagement.assetViewsGraph.loading,
      data: state.legacyRootReducer.reports.engagement.assetViewsGraph.item,
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.asset_views
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.asset_views
    };
  }
)(Timeseries);

//List Reports
const PopularAssetsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.engagement.popularAssets, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "engagement_assets",
      title: `${localizedEngagement.cards.popular_viewers} (${count})`,
      
      list: {
        renderer: Asset.List
      },
      grid: {
        renderer: Asset.Grid,
        columns: [{
          title: '',
          width: 5
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.shares,
          width: 1
        }, {
          title: localizedHeaders.counts.downloads,
          width: 2
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      data: state.legacyRootReducer.reports.engagement.popularAssets,
      fetchData: ownProps.fetchData,
      canSortReport: true,
      downloadProperties: {
        headers: [[localizedHeaders.asset_name], [localizedHeaders.file_type], [localizedHeaders.created_date] , [localizedHeaders.author], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.shares], [localizedHeaders.downloads]],
        fileName: "EngagementPopularAssets.csv"
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.popular_viewers
    }
  }, mapDispatchToProps
)(EntityReport);

const TopViewersReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.engagement.topUsers, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "engagement_viewers",
      title: `${localizedEngagement.cards.top_viewers} (${count})`,
      
      list: {
        renderer: Contact.List
      },
      grid: {
        renderer: Contact.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.reshares,
          width: 2
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      data: state.legacyRootReducer.reports.engagement.topUsers,
      fetchData: ownProps.fetchData,
      showContactsView: ownProps.showContactsView,
      downloadProperties: {
        headers: [[localizedHeaders.contact_name], [localizedHeaders.email], [localizedHeaders.created_date], [localizedHeaders.company], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.reshares]],
        fileName: "EngagementKnownViewers.csv"
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.top_viewers
    }
  }, mapDispatchToProps
)(EntityReport);

const TopAccountsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.engagement.topAccounts, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "engagement_accounts",
      title: `${localizedEngagement.cards.top_accounts} (${count})`,
      
      list: {
        renderer: Contact.Account.List
      },
      grid: {
        renderer: Contact.Account.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.shares,
          width: 2
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      data: state.legacyRootReducer.reports.engagement.topAccounts,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.account_name], [localizedHeaders.contacts], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.counts.shares]],
        fileName: "EngagementAccounts.csv"
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.top_accounts
    }
  }, mapDispatchToProps
)(EntityReport);

const CampaignsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.engagement.campaigns, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "engagement_campaigns",
      title: `${localizedEngagement.cards.campaigns} (${count})`,
      
      list: {
        renderer: Campaign.List
      },
      grid: {
        renderer: Campaign.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.assets,
          width: 2
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      data: state.legacyRootReducer.reports.engagement.campaigns,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.campaign_name], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.assets]],
        fileName: "EngagementCampaigns.csv"
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.campaigns
    }
  }, mapDispatchToProps
)(EntityReport);

const CampaignSourcesReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.engagement.campaignSources, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "engagement_channels",
      title: `${localizedEngagement.cards.content_shared} (${count})`,
      
      list: {
        renderer: Campaign.List
      },
      grid: {
        renderer: Campaign.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.views,
          width: 2
        }, {
          title: localizedHeaders.avg_time,
          width: 2
        }, {
          title: localizedHeaders.counts.assets,
          width: 2
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      data: state.legacyRootReducer.reports.engagement.campaignSources,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.campaign_source], [localizedHeaders.views], [localizedHeaders.avg_time], [localizedHeaders.assets]],
        fileName: "EngagementChannels.csv"
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.content_shared
    }
  }, mapDispatchToProps
)(EntityReport);

const ShareActivitiesReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.engagement.conversationActivities, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "engagement_conversations",
      title: `${localizedEngagement.cards.conversation_activity} (${count})`,
      
      list: {
        renderer: Share.List
      },
      grid: {
        renderer: Share.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.created_by,
          width: 2
        }, {
          title: localizedHeaders.created_on,
          width: 2
        }, {
          title: localizedHeaders.shared_via,
          width: 1
        }, {
          title: localizedHeaders.open_rate,
          width: 1
        }, {
          title: localizedHeaders.click_rate,
          width: 1
        }, {
          title: localizedHeaders.time_spent,
          width: 1
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      data: state.legacyRootReducer.reports.engagement.conversationActivities,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.name], [localizedHeaders.assets], [localizedHeaders.recipients], [localizedHeaders.shared_by], [localizedHeaders.shared_on], [localizedHeaders.shared_via], [localizedHeaders.open_rate], [localizedHeaders.click_rate], [localizedHeaders.time_spent]],
        fileName: "EngagementConversations.csv"
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.conversation_activity
    }
  }, mapDispatchToProps
)(EntityReport);

const CollectionActivitiesReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.engagement.collectionActivities, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedEngagement = localizedReport.tabs.engagement;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "engagement_collections",
      title: `${localizedEngagement.cards.collection_activity} (${count})`,
      
      list: {
        renderer: Collection.List
      },
      grid: {
        renderer: Collection.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.created_by,
          width: 2
        }, {
          title: localizedHeaders.created_on,
          width: 2
        }, {
          title: localizedHeaders.last_updated,
          width: 2
        }, {
          title: localizedHeaders.shares,
          width: 1
        }, {
          title: localizedHeaders.views,
          width: 1
        }]
      },
      supportedEntities: [USER, USER_GROUP, ASSET, CONTACT, COLLECTION, COMPANY],
      data: state.legacyRootReducer.reports.engagement.collectionActivities,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.name], [localizedHeaders.created_by], [localizedHeaders.created_on], [localizedHeaders.last_updated], [localizedHeaders.assets], [localizedHeaders.views], [localizedHeaders.shares]],
        fileName: "EngagementCollections.csv"
      },
      tooltipText: localizedEngagement.cards.tooltip_texts.collection_activity
    }
  }, mapDispatchToProps
)(EntityReport);

export default EngagementReportView;    